var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Separator"},[_c('hr',{staticClass:"line"}),_vm._v(" "),(_vm.icon)?_c('icon',{staticClass:"sep-icon",attrs:{"name":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }